export default __webpack_public_path__ + "static/media/img4.ba6f6486.png";